module.exports = __webpack_public_path__ + "img/hyper_elephant.6ad1f910.png";